export default __webpack_public_path__ + "static/media/img-virtual-building-4.87f39cc5.png";